<template>
    <div :class="[template]" class="notification-card alert alert-dismissible fade show border shadow-sm" role="alert">
        <button type="button" class="notification-close btn-close" data-bs-dismiss="alert" :aria-label="$t('management_console.common.close')" @click="close()"></button>
        <div class="notification-content d-flex align-items-start">
            <div class="notification-icon align-self-center">
                <BootstrapIcon :color="icon_color" :name="icon" :size="26" class="me-3" />
            </div>
            <div class="notification-copy m-0 noselect small">
                <span v-if="title" class="notification-title d-block mb-1 fs-5 fw-light">{{title}}</span>
                <span v-html="msg" class="notification-message fs-6"></span>
            </div>
        </div>
    </div>
</template>

<script>
import { ALERT_VALIDITY_MS } from '@/common/constants'
import BootstrapIcon from '@/common/directive/BootstrapIcon'

export default {
    components: {
        BootstrapIcon
    },
    props: {
        config: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            id: '',
            msg: '',
            template: '',
            icon: '',
            icon_color: ''
        }
    },
    created: function () {
        this.id = this.config.id
        this.msg = this.config.msg
        this.title = this.config.title
        switch (this.config.level) {
        case 'success':
            this.template = 'bg-white border-teal-500'
            this.icon = 'check-circle-fill'
            this.icon_color = 'fill-teal-500 text-teal-500'
            break
        case 'info':
            this.template = 'bg-white border-blue-500'
            this.icon = 'exclamation-triangle'
            this.icon_color = 'fill-blue-500 text-blue-500'
            break
        case 'warning':
            this.template = 'bg-white border-yellow-500'
            this.icon = 'question-circle'
            this.icon_color = 'fill-yellow-600 text-yellow-600'
            break
        case 'danger':
            this.template = 'bg-white border-red-500'
            this.icon = 'patch-exclamation'
            this.icon_color = 'fill-red-500 text-red-500'
            break
        }
    },
    mounted: function () {
        const self = this
        setTimeout(() => {
            self.close()
        }, ALERT_VALIDITY_MS)
    },
    methods: {
        close: function () {
            this.$parent.close({ id: this.id })
        }
    }
}
</script>
